import * as React from "react";
const SvgHinweis = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Hinweis">
    <circle cx={128} cy={80.79} r={10.55} fill="currentColor" />
    <path
      fill="currentColor"
      d="M135.5 113.67v-7.5c0-4.14-3.36-7.5-7.5-7.5h-20.46c-4.14 0-7.5 3.36-7.5 7.5s3.36 7.5 7.5 7.5h12.96v63.41h-9.49c-4.14 0-7.5 3.36-7.5 7.5s3.36 7.5 7.5 7.5h33.98c4.14 0 7.5-3.36 7.5-7.5s-3.36-7.5-7.5-7.5h-9.49z"
    />
    <path
      fill="currentColor"
      d="M128 21.27C69.15 21.27 21.27 69.15 21.27 128S69.15 234.73 128 234.73 234.73 186.85 234.73 128 186.85 21.27 128 21.27m0 198.46c-50.58 0-91.73-41.15-91.73-91.73S77.42 36.27 128 36.27s91.73 41.15 91.73 91.73-41.15 91.73-91.73 91.73"
    />
  </svg>
);
export default SvgHinweis;
